import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}/api`,
  withCredentials: true,
});

api.interceptors.request.use(
  (config) => {
    config.headers["Content-Type"] = "application/json";
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const statusCode = error.response?.status;
    const isLoginStep = ["/admins/login", "/admins/verify-otp"].includes(error.config?.url);
    if (statusCode === 401 && !isLoginStep) {
      window.location.href = "/login";
    }
    return Promise.reject(error);
  },
);

export default api;
